//
// Copyright 2024 DXOS.org
//

export const defs = {
  issueUrl: 'https://github.com/dxos/dxos/issues',
};
